<template>
    <div class="app" id="app">
        <TheHeader></TheHeader>
          <router-view/>
        <TheFooter></TheFooter>
    </div>
</template>

<script>
    import TheHeader from "./components/TheHeader";
    import TheFooter from "./components/TheFooter";

    export default {
        name: 'App',
        components: {
            TheHeader,
            TheFooter
        },

    }
</script>

<style lang="scss">
    @import 'assets/sass/app.scss';
</style>
